import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as echarts from 'echarts';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { calculateFiscalYear, createChart, formatYearRanges } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ExpenseDashboardDetailsComponent } from '../expense-dashboard-details/expense-dashboard-details.component';
import * as moment from 'moment';
import { DateRange } from '@angular/material/datepicker';
import { DateRangeService, DateRangeOption } from 'src/app/date-range.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-expense-dashboard',
  templateUrl: './expense-dashboard.component.html',
  styleUrls: ['./expense-dashboard.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExpenseDashboardComponent implements OnInit, OnDestroy {

  buttonColorName: any;
  loggedInUserName: any;
  subModuleButtonColor: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  selectedYearForReimbursementTop: any;     // For top fiscal year filter
  selectedYearForReimbursementGraph: any;   // For First Graoh

  loggedInUserId: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any;
  isShowMD: any;
  genderWiseData: any = [];
  dropdownSettings: IDropdownSettings = {};
  taskFromDate: any;
  taskToDate: any; // Holds the filtered data
  reimbursementData: any[] = [];
  reimbursementTypeCount: any[] = [];
  reimbursementTypeTable: any[] = [];
  pmsYears: any = []
  selectedYearForReimbursement: any = null;
  selectedYearForDashboard: any;
  currentYearSelected: any;
  fromYear: any;
  toYear: any;
  selectedFromDated: any;
  selectedtoDated: any;
  selectGraphType: any = 'bar';
  selectGraphTwoType: any = 'bar';
  selectGraphThreeType: any = 'bar';
  totalExpenseRaisedCount: any;
  employPendingCount: any;
  totalExpenseApprovedByfinance: any;
  totalExpensePendingByfinance: any;
  userId: any;
  employeeCount: any;
  employeeApprovedCount: any;
  employeeRejectedCount: any;
  employeIDFromUserTable: any;
  raisedEmployeeUnderManager: any;
  approvedEmployeeUnderManager: any;
  rejectedEmployeeUnderManager: any;
  pendingEmployeeUnderManager: any;
  getEmployeeList: any = [];
  OnlyFinance: boolean = false;
  OnlyManager: any;
  selectUserId: any;
  passApprovematrixForReport: any;
  pendingWithManager: any;
  arrEmployeeDetiails: any = [];
  employeeID: any;
  forEmployeDDlogginUserID: any;
  currentPendingWithManager: any;
  selectFromDate: any = null;
  selectToDate: any = null;
  selectFromDateThird: any = null;
  selectToDateThird: any = null;
  selectedOptioMain: string = 'thisMonth';
  selectedOption: string = 'thisMonth';
  selectedOptionThird: string = 'thisMonth';
  dateRangeOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: 'last7' },
    { label: 'Last 30 Days', value: 'last30' },
    { label: 'This Month', value: 'thisMonth' },
    { label: 'Last Month', value: 'lastMonth' },
    { label: 'Custom Range', value: 'custom' },
    { label: 'Fiscal Year', value: 'fiscal' }
  ];
  clientLogoDataUrl: any;
  selectedtoDatedThird: any;
  selectedFromDatedThird: any;
  checkFinanceAdmin: boolean = false;
  financeNoOfExpensesRaised: any = [];
  loginFinanceAdminId: number | null = null;
  taskFromDateAllGraph: any;
  taskToDateAllGraph: any;
  loggedInHODManager: any;

  constructor(public router: Router, private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, private activatedroute: ActivatedRoute, public sharedService: SharedService, public dialog: MatDialog,
    private fb: FormBuilder, private datePipe: DatePipe, private cdRef: ChangeDetectorRef, private PdfDownload: PdfDownloadService, private dateRangeService: DateRangeService, public mobileResponsiveService: MobileResponsiveService
  ) {

  }
  setTaskDateRange(option: DateRangeOption): void {
    const { fromDate, toDate } = this.dateRangeService.getDateRange(option);
    this.taskFromDate = fromDate;
    this.taskToDate = toDate;
  }
  ngOnInit() {

    setTimeout(() => {
      this.loginFinanceAdminId = this.sharedService.getCurrentFinanceAdminId();
      this.OnlyFinance = this.loginFinanceAdminId == this.loggedInUserId;
      console.log("----------  this.OnlyFinance---1-----------", this.OnlyFinance);

    }, 600);

    this.loggedInHODManager = sessionStorage.getItem('HODManager');

    this.httpService.employeIDUnderManager.subscribe((data: any) => {
      this.employeIDFromUserTable = data
    })
    this.clientLogoDataUrl = sessionStorage.getItem('companyLogo');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    let loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = loggedInUserId ? Number(loggedInUserId) : null;
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.userId = this.loggedInUserId;
    this.loggdinUserIDBydefault = this.loggedInUserId;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.getpmsyearlist();
    this.getEmployee();
    this.getEmployeeDetiails();
    this.employeeID = this.loggedInUserId;


    setTimeout(() => {



      this.passApprovematrixForReport = this.httpService.passApprovematrixForReport;
      this.dashBoardreimbursmentData('allGraph');

      this.selectedFromDatedThird = moment().startOf('month').toDate();
      this.selectedtoDatedThird = moment().endOf('month').toDate();

      this.getApprovedPaidAmountByCount('bar', this.selectedYearForThirdGraph);

    }, 100)

    this.forEmployeDDlogginUserID = parseInt(this.loggedInUserId);

    let today = new Date();
    // Set the taskFromDate to 15 days before today's date
    let taskFromDate = new Date(today);
    taskFromDate.setDate(today.getDate() - 12);
    this.taskFromDateForAllGraph = taskFromDate.toISOString().split('T')[0];

    // Set the taskToDate to today's date
    let taskToDate = new Date(today);
    taskToDate.setDate(today.getDate() + 2);
    this.taskToDateForAllGraph = taskToDate.toISOString().split('T')[0];

  }



  onChangeExpenseDate(option: string, graphType: any) {

    if (graphType == 'thirdGraph') {
      this.onRangeSelect(option, graphType);
      this.selectedYearForThirdGraph = sessionStorage.getItem('fiscalYear')
    } else if (graphType == 'FirstGraph') {
      this.onRangeSelect(option, graphType);
    } else if (graphType == 'allGraph') {
      this.onRangeSelectForAllGraph(option, graphType);
      this.selectedOption = option;
      this.selectedOptionThird = option;
    }

    if (option !== 'fiscal' && graphType == 'allGraph') {
      this.getpmsyearlist();
    } else if (option !== 'fiscal' && graphType == 'FirstGraph') {
      this.getpmsyearlist();
    } else if (option !== 'fiscal' && graphType == 'thirdGraph') {
      this.getpmsyearlist();
    }

    if (option !== 'custom' && graphType == 'allGraph') {
      this.taskDateRange = new DateRange(null as Date | null, null as Date | null); // Reset date range
      this.taskDateRangeFirstGraph = new DateRange(null as Date | null, null as Date | null); // Reset date range
      this.taskDateRangethirdGraph = new DateRange(null as Date | null, null as Date | null);
    } else if (option !== 'custom' && graphType == 'FirstGraph') {
      this.taskDateRangeFirstGraph = new DateRange(null as Date | null, null as Date | null); // Reset date range
    } else if (option !== 'custom' && graphType == 'thirdGraph') {
      this.taskDateRangethirdGraph = new DateRange(null as Date | null, null as Date | null); // Reset date range
    }


    if (option == 'custom' && graphType == 'allGraph') {
      this.totalExpenseRaisedCount = 0;
      this.totalExpenseApprovedByfinance = 0;
      this.totalExpensePendingByfinance = 0;
      this.pendingWithManager = 0
      this.selectFromDate = '';
      this.selectedFromDated = '';

      this.getReimbursementCount([], 'bar', this.selectedYearForDashboard, '', '');
      this.reimbursementTypeTable = [];
      this.arrApprovedPaidAmountTable = [];

      this.getApprovedPaidAmountByCount('bar', '');
    } else if (option == 'custom' && graphType == 'FirstGraph') {
      this.selectedtoDated = '';
      this.selectedFromDated = '';
      this.selectFromDate = '';

      this.getReimbursementCount([], 'bar', this.selectedYearForDashboard, '', '');

    } else if (option == 'custom' && graphType == 'thirdGraph') {
      this.selectedtoDated = '';
      this.selectedFromDated = '';
      this.selectFromDate = '';
      this.reimbursementTypeTable = [];
      this.arrApprovedPaidAmountTable = [];
      this.getApprovedPaidAmountByCount('bar', '');
    }
  }

  onRangeSelect(option: string, graphType: any) {
    if (graphType == 'allGraph') {
      this.onChangeExpenseDate(option, 'thirdGraph');
    }

    const today = moment();

    switch (option) {
      case 'today':
        this.taskFromDate = today.startOf('day').toDate();
        this.taskToDate = today.endOf('day').toDate();
        break;

      case 'yesterday':
        this.taskFromDate = today.subtract(1, 'day').startOf('day').toDate();
        this.taskToDate = moment().subtract(1, 'day').endOf('day').toDate();
        break;

      case 'last7':
        this.taskFromDate = moment().subtract(6, 'days').startOf('day').toDate();
        this.taskToDate = moment().endOf('day').toDate();
        break;

      case 'last30':
        this.taskFromDate = moment().subtract(29, 'days').startOf('day').toDate();
        this.taskToDate = moment().endOf('day').toDate();
        break;

      case 'thisMonth':
        this.taskFromDate = moment().startOf('month').toDate();
        this.taskToDate = moment().endOf('month').toDate();
        break;

      case 'lastMonth':
        this.taskFromDate = moment().subtract(1, 'month').startOf('month').toDate();
        this.taskToDate = moment().subtract(1, 'month').endOf('month').toDate();
        break;

      case 'fiscal':
        // You can make a year list like 2023-24, 2024-25 in another dropdown
        // For example, April to March fiscal year
        const fiscalStart = moment().month() < 3
          ? moment().subtract(1, 'year').month(3).startOf('month')
          : moment().month(3).startOf('month');

        const fiscalEnd = fiscalStart.clone().add(1, 'year').subtract(1, 'day');
        this.taskFromDate = fiscalStart.toDate();
        this.taskToDate = fiscalEnd.toDate();
        break;

      case 'custom':
        // Do nothing; user will pick manually
        this.taskFromDate = null;
        this.taskToDate = null;
        break;
    }
    console.log(this.taskFromDate, '--------------------------355-------------------------', this.taskToDate)
    console.log(this.selectedYearForThirdGraph, "-------------------------------336------------------")
    this.processFirstGraphDateRange(graphType, this.taskFromDate, this.taskToDate);

  }


  onRangeSelectForAllGraph(option: string, graphType: any) {
    if (graphType == 'allGraph') {
      this.onChangeExpenseDate(option, 'thirdGraph');
    }

    const today = moment();

    switch (option) {
      case 'today':
        this.taskFromDateAllGraph = today.startOf('day').toDate();
        this.taskToDateAllGraph = today.endOf('day').toDate();
        break;

      case 'yesterday':
        this.taskFromDateAllGraph = today.subtract(1, 'day').startOf('day').toDate();
        this.taskToDateAllGraph = moment().subtract(1, 'day').endOf('day').toDate();
        break;

      case 'last7':
        this.taskFromDateAllGraph = moment().subtract(6, 'days').startOf('day').toDate();
        this.taskToDateAllGraph = moment().endOf('day').toDate();
        break;

      case 'last30':
        this.taskFromDateAllGraph = moment().subtract(29, 'days').startOf('day').toDate();
        this.taskToDateAllGraph = moment().endOf('day').toDate();
        break;

      case 'thisMonth':
        this.taskFromDateAllGraph = moment().startOf('month').toDate();
        this.taskToDateAllGraph = moment().endOf('month').toDate();
        break;

      case 'lastMonth':
        this.taskFromDateAllGraph = moment().subtract(1, 'month').startOf('month').toDate();
        this.taskToDateAllGraph = moment().subtract(1, 'month').endOf('month').toDate();
        break;

      case 'fiscal':
        // You can make a year list like 2023-24, 2024-25 in another dropdown
        // For example, April to March fiscal year
        const fiscalStart = moment().month() < 3
          ? moment().subtract(1, 'year').month(3).startOf('month')
          : moment().month(3).startOf('month');

        const fiscalEnd = fiscalStart.clone().add(1, 'year').subtract(1, 'day');
        this.taskFromDateAllGraph = fiscalStart.toDate();
        this.taskToDateAllGraph = fiscalEnd.toDate();
        break;

      case 'custom':
        // Do nothing; user will pick manually
        this.taskFromDate = null;
        this.taskToDate = null;
        break;
    }
    this.processFirstGraphDateRange(graphType, this.taskFromDateAllGraph, this.taskToDateAllGraph);

  }
  processDateRangeOnlyForCustomRange(graphType: string) {
    let fromDate: any;
    let toDate: any;

    if (graphType === 'FirstGraph') {
      fromDate = this.taskDateRangeFirstGraph?.start;
      toDate = this.taskDateRangeFirstGraph?.end;
    } else if (graphType === 'allGraph') {
      fromDate = this.taskDateRange?.start;
      toDate = this.taskDateRange?.end;

      this.taskDateRangethirdGraph = new DateRange(fromDate, toDate);
      this.taskDateRangeFirstGraph = new DateRange(fromDate, toDate);
    } else {
      fromDate = this.taskDateRangethirdGraph?.start;
      toDate = this.taskDateRangethirdGraph?.end;
    }

    const formattedFromDate = new Date(fromDate);
    formattedFromDate.setHours(0, 0, 0, 0);  // Start of day

    const formattedToDate = new Date(toDate);
    formattedToDate.setHours(23, 59, 59, 999);  // End of day

    this.selectedFromDated = formattedFromDate;
    this.selectedtoDated = formattedToDate;
    this.selectFromDate = formattedFromDate;
    this.selectToDate = formattedToDate;

    if (formattedFromDate && formattedToDate) {
      if (graphType === 'FirstGraph') {
        this.dashBoardreimbursmentData(graphType);
      } else if (graphType === 'allGraph') {
        this.dashBoardreimbursmentData(graphType);
        this.selectedFromDatedThird = formattedFromDate;
        this.selectedtoDatedThird = formattedToDate;
        this.getApprovedPaidAmountByCount(
          this.selectGraphThreeType,
          this.selectedYearForThirdGraph
        );
      } else {
        this.isApprovedByFinanceGraphVisible = true;
        this.selectedFromDatedThird = formattedFromDate;
        this.selectedtoDatedThird = formattedToDate;
        this.getApprovedPaidAmountByCount(
          this.selectGraphThreeType,
          this.selectedYearForThirdGraph
        );
      }
    } else {
      console.warn('Date range not selected. Skipping filtering.');
    }


  }


  processFirstGraphDateRange(graphType: string, taskFromDate: any, taskToDate: any) {

    if (taskFromDate && taskToDate) {
      const adjustedFromDate = new Date(taskFromDate);
      adjustedFromDate.setHours(0, 0, 0, 0);

      const adjustedToDate = new Date(taskToDate);
      adjustedToDate.setHours(23, 59, 59, 999);

      const formattedFromDate = this.formatDateToISO(adjustedFromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(adjustedToDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;

      this.selectFromDate = formattedFromDate;
      this.selectToDate = formattedToDate;

      if (graphType === 'FirstGraph') {
        this.dashBoardreimbursmentData(graphType);
      } else if (graphType === 'allGraph') {
        console.log("fffffff---------------------415")
        this.selectedFromDatedThird = formattedFromDate;
        this.selectedtoDatedThird = formattedToDate;
        this.dashBoardreimbursmentData(graphType);

        this.getApprovedPaidAmountByCount(
          this.selectGraphThreeType,
          this.selectedYearForThirdGraph
        );
      } else {
        this.isApprovedByFinanceGraphVisible = true;
        this.selectedFromDatedThird = formattedFromDate;
        this.selectedtoDatedThird = formattedToDate;
        console.log(this.selectGraphThreeType, "--------------------------491------------", this.selectedYearForThirdGraph, sessionStorage.getItem('fiscalYear'))
        this.getApprovedPaidAmountByCount(
          this.selectGraphThreeType,
          sessionStorage.getItem('fiscalYear')
        );
      }
    } else {
      console.warn('Date range not selected. Skipping filtering.');
    }

  }

  // taskDateRange: DateRange<Date> = new DateRange<Date | null>(null, null);
  taskDateRange: DateRange<Date> = new DateRange(null as Date | null, null as Date | null);
  taskDateRangeFirstGraph: DateRange<Date> = new DateRange(null as Date | null, null as Date | null);
  taskDateRangethirdGraph: DateRange<Date> = new DateRange(null as Date | null, null as Date | null);



  EmployeeSummaryData: any = []

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data?.data;

    })
  }
  getEmployeeDetiails() {

    this.httpService.callGetService(`${this.config.EmployeeDetiailsBandLocation}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      this.arrEmployeeDetiails = result?.data;

    });

  }

  arrExpenseTypeRaised: any;
  loggdinUserIDBydefault: any;
  currentApprovedData: any
  currentPendingData: any

  dashBoardreimbursmentData(graphType: any) {
    console.log("------------------------dashBoardreimbursmentData---------------------------------");

    if (this.selectedFromDated == undefined && this.selectedtoDated == undefined) {
      this.selectedFromDated = moment().startOf('month').toDate();
      this.selectedtoDated = moment().endOf('month').toDate();
    }


    // this.httpService.reimbursementData$.subscribe((response: any) => {
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        console.log("-----------------------------553", response)
        const selectYear = (graphType == 'FirstGraph') ? this.selectedYearForReimbursementGraph : this.selectedYearForReimbursement;

        console.log("----------------selectYear----------------", selectYear)
        let data = response?.data.filter((record: any) => record?.year == selectYear);
        console.log("this.selectedFromDated && this.selectedtoDated", this.selectedFromDated, this.selectedtoDated);

        if (this.selectedFromDated && this.selectedtoDated) {

          const from = new Date(this.selectedFromDated).setHours(0, 0, 0, 0);
          const to = new Date(this.selectedtoDated).setHours(23, 59, 59, 999);

          data = data.filter((record: any) => {
            const recordDate = new Date(record.date).getTime();
            return recordDate >= from && recordDate <= to;
          });

        }


        let ApprovedBYFinace, pendingBYFinace;


        setTimeout(() => {
          console.log(this.loggedInHODManager, "-----------------------------577----------------------********-------------", this.loginFinanceAdminId);


          if (this.loggedInUserRole == 'Employee') {
            //-------------------------------------Employee----
            console.log("In  Employee Side");
            console.log(this.loginFinanceAdminId, "-------------509---------", this.loggedInUserId);

            if (this.loginFinanceAdminId == this.loggedInUserId) {
              // For Finance??
              console.log("For Finance");
              this.OnlyFinance = true;
              console.log("----------  this.OnlyFinance---2-----------", this.OnlyFinance);
              // let ManagerEmployeeDorpDownData = data.filter((record: any) => record.financeId == this.loggedInUserId);
              let ManagerEmployeeDorpDownData;
              if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
                ManagerEmployeeDorpDownData = data.filter((elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))));
                pendingBYFinace = ManagerEmployeeDorpDownData.filter((record: any) => (record.approvedStatus == 'PENDING'));
              } else {

                ManagerEmployeeDorpDownData = data.filter((elm: any) => elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))));
                pendingBYFinace = data.filter((record: any) => (record.status == 'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE' ||
                  record.status == 'APPROVED_BY_MANAGER_SENT_TO_FINANCE' && record.financeId == null));
               
              }

              ApprovedBYFinace = (this.loggedInUserRole == 'Super Admin') ? data.filter((record: any) =>
                record.status == 'APPROVED_BY_FINANCE_BUT_NOT_PAID') : data.filter((record: any) =>
                  record.approvedStatus == 'APPROVED' && record.financeId == this.loggedInUserId);


              const arrExpensData = data.filter((record: any) =>
                record.status === "APPROVED_BY_MANAGER_SENT_TO_FINANCE" ||
                record.financeId == this.loggedInUserId
              );

              // All expenses raised that finance admin can see
              const allFinanceExpenses = data.filter((elm: any) =>
                (elm.financeId === null || elm.financeId === parseInt(this.loggedInUserId)) &&
                elm.status !== "APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN" && elm.status!=="REJECTED_BY_HR_ADMIN"
              );
              console.log("---------3333333333 *****--------------", allFinanceExpenses);
              // if(FirstGraph)
              this.arrExpenseTypeRaised = arrExpensData;
              this.arrExpenseTypeRaised = data;
              this.financeNoOfExpensesRaised = arrExpensData;
              this.totalExpenseRaisedCount = allFinanceExpenses.length;
              console.log("-----------totalExpenseRaisedCount11 *--------------", this.totalExpenseRaisedCount);

              // this.totalExpenseRaisedCount = data.length;
              this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
              this.totalExpensePendingByfinance = pendingBYFinace.length;
            

            } else {
              // For Employee
              console.log("For Employee");

              let matchData = data.filter((elm: any) => elm.employeeId == this.userId);

              this.employeeCount = matchData
              this.employeeApprovedCount = this.employeeCount.filter((elm: any) => elm.approvedStatus == 'APPROVED');
              this.employeeRejectedCount = this.employeeCount.filter((elm: any) => elm.approvedStatus == 'REJECTED');

              if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
                this.employPendingCount = this.employeeCount.filter((elm: any) => (elm.approvedStatus == 'PENDING' && elm.status !='APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN'));
              } else {
                this.employPendingCount = this.employeeCount.filter((elm: any) => (elm.approvedByManager == 'APPROVED' && elm.approvedStatus == 'PENDING' && elm.status != 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN'));

              }
              console.log("--------------------------573--------------------", graphType);

              this.arrExpenseTypeRaised = this.employeeCount;
              if (graphType != 'FirstGraph') {
                this.totalExpenseRaisedCount = matchData.length;
                console.log("emplyeee raised11...",    this.totalExpenseRaisedCount);
                console.log("@@@@@@@@@@@Pending by finance",this.employPendingCount)
                this.totalExpenseApprovedByfinance = this.employeeApprovedCount.length;
                this.totalExpensePendingByfinance = this.employPendingCount.length;
                console.log("Length of total pending by finance",  this.totalExpensePendingByfinance);
                
              }

            }

          } else if (this.loggedInUserRole != 'Super Admin' && this.loggedInUserRole != 'Employee' && this.loggedInUserRole != 'Manager' && this.loggedInHODManager != 'HODManager' && this.loggedInUserRole != 'HOD' && this.loggedInUserRole != 'MD') {
            console.log("In  HR Admin Side    " + this.loggedInUserRole);


            //---------------------------------------------------HR Loggin-----------
            ApprovedBYFinace = data.filter((record: any) => record.approvedStatus == 'APPROVED');
            pendingBYFinace = data.filter((record: any) => (record.approvedStatus == 'PENDING' && record.approvedByManager == 'APPROVED' &&     record.status !== 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN' ));

            this.arrExpenseTypeRaised = data;


            if (graphType == 'allGraph') {
              this.totalExpenseRaisedCount = data.length;
              this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
              this.totalExpensePendingByfinance = pendingBYFinace.length;

            }
            // if((graphType == 'FirstGraph'))



          } else if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && ((this.loginFinanceAdminId == 0 || this.loginFinanceAdminId == null) && this.loginFinanceAdminId != this.loggedInUserId)) {
            //------------------------------------------Manager-------------------------------------------------------------------------
            console.log("In  Manager Side");



            const loggdinguserId = this.loggedInUserId
            this.OnlyManager = (this.loggedInUserId != this.forEmployeDDlogginUserID) ? true : false;

            let managerEmployeId: string | any[];
            let ManagerEmployeeDorpDownData: any;
            setTimeout(() => {
              managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);

              ManagerEmployeeDorpDownData = data.filter((record: any) => managerEmployeId?.includes(record.employeeId) || record.employeeId == loggdinguserId);

              let getEmployeeListFromApi = this.removeDuplicateEmployeeIds(ManagerEmployeeDorpDownData);


              const userLoginData = (this.loggedInUserRole !== 'Manager' || this.loggedInHODManager != 'HODManager') ? [{
                employeeName: this.loggedInUserName,
                employeeId: parseInt(this.loggedInUserId)
              }] : [];

              const getEmployeeList = [...userLoginData, ...getEmployeeListFromApi];
              const filteredEmployeeList = getEmployeeList.filter(emp => emp.employeeId !== parseInt(this.loggedInUserId));


              // getEmployeeList.map((elm: any) => {
              //   if (!this.getEmployeeList.some((record: any) => record.employeeId === elm.employeeId)) {
              //     this.getEmployeeList.push(elm);
              //   }
              // });
              filteredEmployeeList.map((elm: any) => {
                if (!this.getEmployeeList.some((record: any) => record.employeeId === elm.employeeId)) {
                  this.getEmployeeList.push(elm);
                }
              });


              this.employeeID = this.forEmployeDDlogginUserID

            }, 100);

            console.error("------609-------------data---", data)
            this.raisedEmployeeUnderManager = data.filter((record: any) => record.employeeId == this.loggdinUserIDBydefault);
            this.approvedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'APPROVED');

            const pendingWithManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == null || record.approvedByManager == 'PENDING') && this.loggedInUserId != record.employeeId);
            console.error("------609-------------raisedEmployeeUnderManager---", this.raisedEmployeeUnderManager)
            this.pendingWithManager = pendingWithManager.length;
            this.currentPendingWithManager = pendingWithManager.length;

            this.rejectedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'REJECTED');


            this.pendingEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING' &&  record.status !== 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN' ));
            console.log("@@@@@@@@Manager pending by finance ...",     this.pendingEmployeeUnderManager )
            this.arrExpenseTypeRaised = this.raisedEmployeeUnderManager;
            console.log("-----------------------------624------------------------", this.raisedEmployeeUnderManager);

            this.totalExpenseRaisedCount = this.raisedEmployeeUnderManager.length;
            this.totalExpenseApprovedByfinance = this.approvedEmployeeUnderManager.length;
            this.totalExpensePendingByfinance = this.pendingEmployeeUnderManager.length;

          } else {
            if (this.loggedInUserRole === 'Super Admin') {

              //---------------------------------------------------HR Loggin-----------
              ApprovedBYFinace = data.filter((record: any) => record.approvedStatus == 'APPROVED');
              pendingBYFinace = data.filter((record: any) => (record.approvedStatus == 'PENDING' && record.approvedByManager == 'APPROVED'));

              this.arrExpenseTypeRaised = data;


              if (graphType == 'allGraph') {
                this.totalExpenseRaisedCount = data.length;
                this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
                this.totalExpensePendingByfinance = pendingBYFinace.length;

              }
              // if((graphType == 'FirstGraph'))

            } else {
              console.log("----------  this.OnlyFinance + manager ---3-----------", this.OnlyFinance);
              if (!this.OnlyFinance) return;
              console.log("In  Fianace Side   629");
              // let ManagerEmployeeDorpDownData = data.filter((record: any) => record.financeId == this.loggedInUserId);
              let ManagerEmployeeDorpDownData;
              if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
                ManagerEmployeeDorpDownData = data.filter((elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))));


                // pendingBYFinace = ManagerEmployeeDorpDownData.filter((record: any) => (record.approvedStatus == 'PENDING'));
                // ✅ Pending by Finance
                pendingBYFinace = ManagerEmployeeDorpDownData.filter((record: any) =>
                  record.approvedStatus == 'PENDING' &&
                  (record.status == 'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE' ||
                    record.status == 'APPROVED_BY_MANAGER_SENT_TO_FINANCE')
                );
              } else {

                ManagerEmployeeDorpDownData = data.filter((elm: any) => elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))));
                // pendingBYFinace = data.filter((record: any) => (record.status == 'APPROVED_BY_MANAGER_SENT_TO_FINANCE'));
                // ✅ Pending by Finance
                pendingBYFinace = data.filter((record: any) =>
                  (record.status == 'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE' ||
                    record.status == 'APPROVED_BY_MANAGER_SENT_TO_FINANCE') &&
                  record.financeId == null
                );
              }

              ApprovedBYFinace = (this.loggedInUserRole == 'Super Admin') ? data.filter((record: any) =>
                record.status == 'APPROVED_BY_FINANCE_BUT_NOT_PAID') : data.filter((record: any) =>
                  record.approvedStatus == 'APPROVED' && record.financeId == this.loggedInUserId);



              this.arrExpenseTypeRaised = ManagerEmployeeDorpDownData;
              this.arrExpenseTypeRaised = data;
              this.financeNoOfExpensesRaised = ManagerEmployeeDorpDownData;
              this.totalExpenseRaisedCount = ManagerEmployeeDorpDownData.length;
              console.log("-------------------------", this.totalExpenseRaisedCount);

              // this.totalExpenseRaisedCount = data.length;
              this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
              this.totalExpensePendingByfinance = pendingBYFinace.length;
            }

          }

          this.currentApprovedData = this.totalExpenseApprovedByfinance
          this.currentPendingData = this.totalExpensePendingByfinance

          // -----------------------------------------FINAL DATA----------------------------------------------------------------------

          const reimbursementCounts = this.arrExpenseTypeRaised.reduce((acc: any, item: any) => {
            acc[item.reimbursementType] = (acc[item.reimbursementType] || 0) + 1;
            return acc;
          }, {});


          const result = Object.entries(reimbursementCounts).map(([type, count]) => ({
            reimbursementType: type,
            count: count,
          }));

          this.reimbursementTypeCount = result;

          console.log(this.selectedFromDated, "---------------------742---------------------------", this.selectedtoDated);

          if (this.selectedFromDated && this.selectedtoDated) {

            const selectYear = (graphType == 'FirstGraph') ? this.selectedYearForReimbursementGraph : this.selectedYearForReimbursement;

            this.getReimbursementCount(
              result,
              'bar',
              selectYear,
              this.selectedFromDated,
              this.selectedtoDated
            );
          } else {
            console.log('No filtering applied for Graph 1, returning all data');
          }

          this.getReimbursementYearlyByCount('bar');
          this.processAllGraphDateRange();
          this.cdRef.detectChanges();
          this.switchReimbursementTypeGraph('bar');


        }, 600);

      });
  }

  removeDuplicateEmployeeIds(data: any[]) {
    const seen = new Set();
    return data.filter((item) => {
      if (seen.has(item.employeeId)) {
        return false;
      }
      seen.add(item.employeeId);
      return true;
    });
  }



  getpmsyearlist() {

    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYearRanges(data?.data?.yearRanges)
        ?.filter((item: any) => {
          const year = parseInt(item.year?.split('-')[0], 10);
          return year <= new Date().getFullYear();
        }) || [];

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      sessionStorage.setItem('fiscalYear', yearValue);
      console.log(yearValue, "*---------------------------862------------------", yearValue)
      this.selectedYearForThirdGraph = yearValue;
      this.setSelectedYear(yearValue);
      this.selectedYearForReimbursementTop = this.currentYearSelected;
      this.selectedYearForReimbursementGraph = this.currentYearSelected;
      this.cdRef.detectChanges();
      this.getEmployee();

    });
  }
  selectedYearForThirdGraph: any
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      // this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForReimbursement = selectedYearObj?.year;
      this.selectedYearForDashboard = selectedYearObj?.year;
      this.selectedYearForThirdGraph = selectedYearObj?.year;
      this.currentYearSelected = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }


  // Date Range
  taskFromDateForThirdGraph: any;
  taskToDateForThirdGraph: any;


  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }

  ChangeformatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${day}-${month}-${year}`;
  }


  taskToDateForAllGraph: any;
  taskFromDateForAllGraph: any

  processAllGraphDateRange() {

    this.taskFromDate = this.taskFromDateForAllGraph;
    this.taskToDate = this.taskToDateForAllGraph;
    this.taskFromDateForThirdGraph = this.taskFromDateForAllGraph;
    this.taskToDateForThirdGraph = this.taskToDateForAllGraph;
    // this.onDateChangeDashboardForExpenseForExpense();

  }


  isReimbursementTypeIcon: any = 'bar';
  isApprovedByFinanceIcon: any = 'bar';
  isFinanceAmountPaidIcon: any = 'bar';
  isApprovedByPaidAmountIcon: any = 'bar';
  isReimbursementTypeTable: any = false;
  isApprovedByFinanceTable: any = false;
  isApprovedByPaidAmountTable: any = false;

  // Reimbursement Type Year
  // For Year Select

  onChangeFiscalYear(year: any, graphType: any) {
    this.selectedYearForReimbursementGraph = year;
    console.log(year)
    // Extract start and end years from the selected fiscal year string
    const fiscalYears = year.split('-');
    const fiscalStartYear = parseInt(fiscalYears[0], 10);
    const fiscalEndYear = parseInt(fiscalYears[1], 10);

    // Construct fixed fiscal year date range
    let startDate;
    let endDate;
    if (fiscalStartYear == fiscalEndYear) {
      startDate = new Date(`${fiscalStartYear}-01-01`);
      endDate = new Date(`${fiscalEndYear}-12-31`);
    } else {
      startDate = new Date(`${fiscalStartYear}-04-01`);
      endDate = new Date(`${fiscalEndYear}-03-31`);
    }


    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error('Invalid start or end date:', startDate, endDate);
      return;
    }

    // Format as yyyy-mm-dd
    this.taskFromDate = startDate.toISOString().split('T')[0];
    this.taskToDate = endDate.toISOString().split('T')[0];

    this.processFirstGraphDateRange(graphType, this.taskFromDate, this.taskToDate);
  }


  isReimbursementGraphVisible: boolean = true;
  isApprovedByFinanceGraphVisible: boolean = true;



  onChangeFiscalYearTop(year: any, graphType: any) {

    this.selectedYearForReimbursement = year;
    this.selectedYearForReimbursementGraph = year;
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        let data = response?.data.filter((record: any) => record?.year == year) || [];

        if (!data.length) {
          // No data for the selected year — reset all relevant values
          this.totalExpenseRaisedCount = 0;
          this.totalExpenseApprovedByfinance = 0;
          this.totalExpensePendingByfinance = 0;
          this.arrExpenseTypeRaised = [];
          this.reimbursementTypeCount = [];
          this.currentApprovedData = 0;
          this.currentPendingData = 0;
          this.pendingWithManager = 0;
          this.arrApprovedPaidAmountTable = [];
          // this.isFinanceAmountPaidGraphVisible = false;
          this.isReimbursementGraphVisible = false;
          this.isApprovedByFinanceGraphVisible = false;
          return;
        }

        // If data exists
        this.isReimbursementGraphVisible = true;
        this.isApprovedByFinanceGraphVisible = true;
        this.dashBoardreimbursmentData(graphType);
        this.isFinanceAmountPaidGraphVisible = true; // Show graph
        this.getApprovedPaidAmountByCount(this.selectGraphThreeType, this.selectedYearForThirdGraph);
      });
  }


  isFinanceAmountPaidGraphVisible: boolean = true;

  onChangeFiscalYearForThirdGraph(year: any, graphType: any) {

    this.selectedYearForThirdGraph = year;
    this.isApprovedByFinanceGraphVisible = true;
    // Call the graph function with updated year and current date range
    this.getApprovedPaidAmountByCount(

      this.selectGraphThreeType,
      this.selectedYearForThirdGraph
    );

  }


  selectedTypeTabIndex: any = 1;
  selectedTypeTabName: any = 'Finance'
  tabTypeChanged(event: any) {

  }


  // Start Graph :  One
  switchReimbursementTypeGraph(graphType: any) {

    this.selectGraphType = graphType;
    this.isReimbursementTypeIcon = graphType;
    this.isReimbursementTypeTable = false;

    // this.selectedYearForReimbursementGraph = this.currentYearSelected;
    if (this.selectFromDate !== '' && this.selectedFromDated !== '') {

      if (graphType == 'bar') {
        console.log("--------------------------getReimbursementCount 2--------------------------------");
        this.getReimbursementCount(this.reimbursementTypeCount, 'bar', this.selectedYearForReimbursementGraph, this.selectFromDate, this.selectToDate);
      }
      if (graphType == 'line') {
        console.log("--------------------------getReimbursementCount 3--------------------------------");
        // this.reimbursementCountLineGraph();
        this.getReimbursementCount(this.reimbursementTypeCount, 'line', this.selectedYearForReimbursementGraph, this.selectFromDate, this.selectToDate);
      }

    }

  }
  switchReimbursementTypeTable() {
    this.selectGraphType = 'table';
    this.isReimbursementTypeIcon = '';
    this.isReimbursementTypeTable = true;
    /*     this.taskFromDate = null;
        this.taskToDate = null; */
    this.selectedYearForReimbursement = this.currentYearSelected;
    console.log("--------------------------getReimbursementCount 4--------------------------------");
    if (this.selectFromDate !== '' && this.selectedFromDated !== '') {
      this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected, this.selectFromDate, this.selectToDate);
    }


  }
  // End Graph :  One

  // Start Graph :  Two
  switchApprovedByFinanceGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isApprovedByFinanceIcon = graphType;
    this.isApprovedByFinanceTable = false;
    if (graphType == 'bar') {
      this.getReimbursementYearlyByCount('bar');
    }
    if (graphType == 'line') {
      this.getReimbursementYearlyByCount('line');
    }

  }

  switchApprovedByFinanceTable() {

    this.selectGraphTwoType = 'table';
    this.isApprovedByFinanceIcon = '';
    this.isApprovedByFinanceTable = true;
    // this.taskFromDate = null;
    // this.taskToDate = null;
    this.selectedYearForReimbursement = this.currentYearSelected;
    // this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected, '', '');

  }
  // End Graph :  Two
  // Start Graph :  Three

  isFinanceAmountPaidTable: boolean = false;
  switchFinanceAmountPaidGraph(graphType: any) {
    this.selectGraphThreeType = graphType;
    this.isFinanceAmountPaidIcon = graphType;
    this.isFinanceAmountPaidTable = false;
    console.log(graphType, "------------------------", this.selectedYearForThirdGraph, this.selectedYearForReimbursement)
    if (this.selectFromDate !== '' && this.selectedFromDated !== '') {
      if (graphType == 'bar') {
        this.getApprovedPaidAmountByCount('bar', this.selectedYearForReimbursement);
      }
      if (graphType == 'line') {
        this.getApprovedPaidAmountByCount('line', this.selectedYearForReimbursement);
      }
    }
  }
  switchFinanceAmountPaidTable() {
    console.log(this.selectedYearForReimbursement);

    this.selectGraphThreeType = 'table';
    this.isFinanceAmountPaidIcon = '';
    this.isFinanceAmountPaidTable = true;
    /*     this.taskFromDate = null;
        this.taskToDate = null; */
    this.selectedYearForReimbursement = this.selectedYearForReimbursement;
    // this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected, '', '');

  }


  // ------------------------- Start For Graph One ------------------------------

  getReimbursementCount(result: { reimbursementType: string; count: unknown; }[], graphType: string, year: any, fromDate: any, toDate: any) {

    let intUserId = (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) ? this.loggdinUserIDBydefault : null;

    const request = {
      "startDate": fromDate,
      "endDate": toDate,
      "employeeId": intUserId,
      "companyId": this.loggedInUserCompanyID,
      "year": year
    };
    console.log("------------------------request-------------------------------------------------", request)


    if (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

      if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && this.OnlyFinance) {
        this.checkFinanceAdmin = true;
        var reimbursementApplications = this.config.HrReimbursementCountSummary;
      } else {
        if (this.OnlyFinance) {
          this.checkFinanceAdmin = true;
          var reimbursementApplications = this.config.HrReimbursementCountSummary;
        } else {
          var reimbursementApplications = this.config.EmployeeReimbursementCountSummary;

        }
      }
    } else {
      var reimbursementApplications = this.config.HrReimbursementCountSummary;
    }

    console.log(reimbursementApplications, "*************1091****************", request, this.OnlyFinance)
    this.httpService.callPostService(reimbursementApplications, request).subscribe((response: any) => {

      let reimbursementAcive = response?.data;

      if (this.checkFinanceAdmin) {
        const typeCountMap: { [key: string]: number } = {};
        this.financeNoOfExpensesRaised.forEach((item: any) => {
          const type = item.reimbursementType;
          if (typeCountMap[type]) {
            typeCountMap[type]++;
          } else {
            typeCountMap[type] = 1;
          }
        });
        const reimbursementActive = Object.keys(typeCountMap).map(type => ({
          reimbursementType: type,
          count: typeCountMap[type]
        }));

        reimbursementAcive = reimbursementActive;

      }


      if (reimbursementAcive) {


        this.isReimbursementGraphVisible = true;
        let reimbursementData = result;

        let mergedData = reimbursementAcive?.map((active: { reimbursementType: string; }) => {
          const matchedData = reimbursementData?.find(
            data => data?.reimbursementType === active.reimbursementType
          );
          return {
            reimbursementType: active.reimbursementType,
            count: matchedData ? matchedData.count : 0
          };
        });


        const reimbursementTypeData = (this.checkFinanceAdmin) ? reimbursementAcive : mergedData;
        this.reimbursementTypeTable = reimbursementTypeData;


        let transformedData = reimbursementTypeData.map((item: any) => ({
          xAxisValueData: item.reimbursementType,
          seriesValueOneData: item.count
        }));

        transformedData.xAxisName = 'Reimbursement Type';
        transformedData.yAxisName = 'Reimbursement Count';
        transformedData.seriesLabelOne = 'Count';
        transformedData.seriesLabelTwo = '';
        if (graphType == 'bar') {

          this.reimbursementBarChartActive(transformedData, 'bar-line-chart', 'single');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData, 'bar-line-chart', 'single');
        }

      } else {

        var transformedData1: any = [];

        if (graphType == 'bar') {
          this.reimbursementBarChartActive(transformedData1, 'bar-line-chart', 'single');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData1, 'bar-line-chart', 'single');
        }

      }

    });
  }
  // End For Graph One

  // Start For Graph Two

  arrApprovedByFinanceTable: any = [];
  getReimbursementYearlyByCount(graphType: string) {
    console.log("*************getReimbursementYearlyByCount***")
    // let intUserId = (this.selectUserId != undefined) ? this.selectUserId : this.loggedInUserId;
    let intUserId = this.loggdinUserIDBydefault;

    let request;

    if (this.OnlyFinance) {
      request = {

        "companyId": this.loggedInUserCompanyID,
        "financeId": this.loggedInUserId
      }
    } else {
      if (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

        if (((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') || this.loggedInUserRole == 'Employee') && this.OnlyFinance) {
          if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
            if ((this.OnlyFinance) && this.loggedInUserRole == 'Employee') {
              request = {
                "companyId": this.loggedInUserCompanyID,
                "employeeId": intUserId
              };
            } else {

              request = {
                "companyId": this.loggedInUserCompanyID,
              };
            }
          } else {

            request = {
              "companyId": this.loggedInUserCompanyID,
              "employeeId": intUserId
            };

          }
        } else {

          request = {
            "companyId": this.loggedInUserCompanyID,
            "employeeId": intUserId
          };

        }

      } else {
        request = {
          "companyId": this.loggedInUserCompanyID,
        };

      }
    }

    this.httpService.callPostService(`${this.config.yearlyReimbursementCountSummary}`, request).subscribe((response: any) => {
      if (response.data?.length > 0) {

        // console.log("---------------------------------1306",reimbursementAcive)
        let reimbursementAcive = response?.data?.map((item: any) => ({
          ...item,
          totalAmount: parseFloat(item.totalAmount.toFixed(2)),
          employeeCount: parseFloat(item.employeeCount.toFixed(2))
        }));
        this.arrApprovedByFinanceTable = reimbursementAcive;



        // Transforming data with new property names
        const transformedData = reimbursementAcive?.map((item: any) => ({
          xAxisValueData: item.year,
          seriesValueOneData: item.totalAmount,
          seriesValueTwoData: item.employeeCount,
        }));

        transformedData.xAxisName = 'Year';
        transformedData.yAxisName = 'Reimbursement Amount';
        transformedData.seriesLabelOne = 'Total Amount';
        transformedData.seriesLabelTwo = 'Employee Count';

        if (graphType == 'bar') {
          this.reimbursementBarChartActive1(transformedData, 'bar-line-approvedByFinance-chart', 'double');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData, 'bar-line-approvedByFinance-chart', 'double');
        }
      } else {
        console.log("Data Not Found : get Reimbursement Yearly By Count")
      }


    });

    // this.getApprovedPaidAmountByCount('bar', this.selectedYearForDashboard, this.taskFromDateForAllGraph,  this.taskToDateForAllGraph);
  }
  // End For Graph Two


  // Start For Graph Three
  arrApprovedPaidAmountTable: any = [];


  // getReimbursementCount(result: { reimbursementType: string; count: unknown; }[], graphType: string, year: any, fromDate: any, toDate: any) {
  getApprovedPaidAmountByCount(graphType: string, year: any) {

    setTimeout(() => {

      this.OnlyFinance = this.loginFinanceAdminId == this.loggedInUserId;
      console.log("----------  this.OnlyFinance---4-----------", this.OnlyFinance);
      let fromDate = this.selectedFromDatedThird;
      let toDate = this.selectedtoDatedThird;
      console.log(fromDate, "-----------------1252-------------------------", toDate)

      if ((fromDate == null && toDate == null) || (fromDate == undefined && toDate == undefined)) {
        console.warn("getApprovedPaidAmountByCount : Check fromDate & toDate")
        return;
      }

      let intUserId;
      if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {

        intUserId = ((this.loggedInUserRole == 'Employee') && (this.OnlyFinance)) ? (this.loggdinUserIDBydefault) :
          ((this.loggedInUserRole == 'Employee') && (this.loginFinanceAdminId != this.loggedInUserId)) ? (this.loggdinUserIDBydefault) :
            (((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) && (this.OnlyFinance)) ? '' :
              (((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) && (this.loginFinanceAdminId != this.loggedInUserId)) ? this.loggdinUserIDBydefault : '';
      }
      else {

        intUserId = (((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') || this.loggedInUserRole == 'Employee') &&
          this.loginFinanceAdminId != this.loggedInUserId) ? (this.loggdinUserIDBydefault) : ((this.loggedInUserRole == 'Employee') &&
            (this.OnlyFinance)) ? (this.loggdinUserIDBydefault) : (((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) &&
              (this.OnlyFinance)) ? this.loggdinUserIDBydefault : '';
      }
      let request;

      if (this.OnlyFinance) {

        request = {
          "startDate": fromDate,
          "endDate": toDate,
          "companyId": this.loggedInUserCompanyID,
          "year": year,
          "employeeId": null,
          "financeId": this.loggedInUserId
        };
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin') {
          request = {
            "startDate": fromDate,
            "endDate": toDate,
            "companyId": this.loggedInUserCompanyID,
            "year": year,
            "employeeId": ''


          };

        } else {
          request = {
            "startDate": fromDate,
            "endDate": toDate,
            "companyId": this.loggedInUserCompanyID,
            "year": year,
            "employeeId": this.loggdinUserIDBydefault
          };

        }
      }

      this.httpService.callPostService(`${this.config.ReimbursementApplicationCountSummary}`, request).subscribe((response: any) => {


        let reimbursementAcive = response?.data?.map((item: any) => ({
          ...item,
          totalAssignedAmount: parseFloat(item.totalAssignedAmount.toFixed(2)),
          totalActualAmount: parseFloat(item.totalActualAmount.toFixed(2))
        }));


        this.arrApprovedPaidAmountTable = reimbursementAcive;

        const transformedDataArray = reimbursementAcive?.map((item: any) => ({
          xAxisValueData: item.reimbursementType,
          seriesValueOneData: item.totalActualAmount,
          seriesValueTwoData: item.totalAssignedAmount,
        }));

        const transformedData = {
          xAxisName: 'Reimbursement Type',
          yAxisName: 'Expense Approved Vs Applied',
          seriesLabelOne: 'Total Actual Amount',
          seriesLabelTwo: 'Total Assigned Amount',
          data: transformedDataArray,
        };

        if (graphType == 'bar') {
          this.isApprovedByFinanceGraphVisible = true;

          console.error("--------------------1356-----------------", transformedData)
          this.reimbursementBarChartActive(transformedData, 'bar-line-amount-chart', 'double');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData, 'bar-line-amount-chart', 'double');
        }

      });

    }, 600);

  }


  private myChart!: echarts.ECharts;

  // Usage for Line Chart
  reimbursementCountLineGraph(data: any, idSelector: any, graphType: any): void {
    const createchart = createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
    this.mobileResponsiveService.chartResizeFn(createchart);
  }

  // Usage for Bar Chart
  reimbursementBarChartActive(data: any, idSelector: any, graphType: any): void {
    const createchart = createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data?.xAxisName,
      yAxisName: data?.yAxisName,
    });
    this.mobileResponsiveService.chartResizeFn(createchart);
  }

  reimbursementBarChartActive1(data: any, idSelector: any, graphType: any): void {
    const createchart = createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
    this.mobileResponsiveService.chartResizeFn(createchart);
  }

  downloadChartAsPDF(type: any, selectedOption: any): void {
    const dateRangeOptions = [
      { label: 'Today', value: 'today' },
      { label: 'Yesterday', value: 'yesterday' },
      { label: 'Last 7 Days', value: 'last7' },
      { label: 'Last 30 Days', value: 'last30' },
      { label: 'This Month', value: 'thisMonth' },
      { label: 'Last Month', value: 'lastMonth' },
      { label: 'Custom Range', value: 'custom' },
      { label: 'Fiscal Year', value: 'fiscal' }
    ];
    this.setTaskDateRange(selectedOption);


    let selectedLabel = dateRangeOptions.find(opt => opt.value === selectedOption)?.label || 'N/A';

    let selectedYearForReimbursement = '';
    let idSelector = '';
    let formattedFromDate: Date;
    let formattedtoDate: Date;

    if (selectedOption === 'thisMonth') {
      this.selectedFromDated = moment().startOf('month').toDate();
      this.selectedtoDated = moment().endOf('month').toDate();
    }

    if (type === 'Total Expense Amount') {
      selectedYearForReimbursement = this.selectedYearForReimbursementGraph;
      selectedLabel = '';

      idSelector = this.selectGraphTwoType === 'table'
        ? 'table-approvedByFinance-data'
        : 'bar-line-approvedByFinance-chart';

      // Use some default or expected range if required
      formattedFromDate = new Date();  // Set appropriately
      formattedtoDate = new Date();    // Set appropriately
    } else if (type === 'Expense Paid VS Applied') {
      const fromDate = this.taskDateRangethirdGraph?.start;
      const toDate = this.taskDateRangethirdGraph?.end;

      if (fromDate == null && fromDate == null) {
        formattedFromDate = this.taskFromDate;
        formattedtoDate = this.taskToDate;
      } else {
        formattedFromDate = new Date(fromDate as Date);
        formattedFromDate.setHours(0, 0, 0, 0);
        formattedtoDate = new Date(toDate as Date);
        formattedtoDate.setHours(23, 59, 59, 999);
      }


      selectedYearForReimbursement = this.selectedYearForReimbursement;
      idSelector = this.selectGraphThreeType === 'table'
        ? 'table-data-Finance-Employee'
        : 'bar-line-amount-chart';
    } else {
      const fromDate = this.taskDateRangeFirstGraph?.start;
      const toDate = this.taskDateRangeFirstGraph?.end;

      if (fromDate == null && fromDate == null) {
        formattedFromDate = this.taskFromDate;
        formattedtoDate = this.taskToDate;
      } else {
        formattedFromDate = new Date(fromDate as Date);
        formattedFromDate.setHours(0, 0, 0, 0);
        formattedtoDate = new Date(toDate as Date);
        formattedtoDate.setHours(23, 59, 59, 999);
      }

      selectedYearForReimbursement = this.selectedYearForReimbursementGraph;
      idSelector = this.selectGraphType === 'table'
        ? 'table-data'
        : 'bar-line-chart';
    }

    if (this.loggedInCompanyFiscalyear === 'Jan_Dec' && selectedYearForReimbursement) {
      selectedYearForReimbursement = selectedYearForReimbursement.split('-')[0];
    }

    const phiEdgeLogoUrl = 'assets/icon/Phiedge-logo_HRMS.png';
    const clientLogoUrl = 'assets/icon/Phiedge-logo_HRMS.png';
    const formattedFromDate1 = this.ChangeformatDateToISO(formattedFromDate);
    const formattedToDate1 = this.ChangeformatDateToISO(formattedtoDate);

    Promise.all([
      this.PdfDownload.getBase64ImageFromURL(phiEdgeLogoUrl),
      this.PdfDownload.getBase64ImageFromURL(clientLogoUrl)
    ])
      .then(([phiEdgeLogoDataUrl, clientLogoDataUrl]) => {
        this.PdfDownload.downloadForExpensePDF(
          idSelector,
          type,
          selectedYearForReimbursement,
          (type === 'Total Expense Amount') ? '' : formattedFromDate1,
          (type === 'Total Expense Amount') ? '' : formattedToDate1,
          selectedLabel,
          phiEdgeLogoDataUrl,
          clientLogoDataUrl
        );
      })
      .catch(error => {
        console.error('Error loading logos:', error);
      });
  }


  //--------------------------------------------------Count Api-------------------------------------------------

  onClickCard(event: any) {

    if (event == 1 && this.totalExpenseRaisedCount.length == 0) {
      return;
    }
    if (event == 3 && this.totalExpenseApprovedByfinance.length == 0) {
      return;
    }
    if (event == 4 && (this.totalExpensePendingByfinance.length == 0 || this.totalExpensePendingByfinance == 0)) {
      return;
    }

    if (event == "Manager" && this.pendingWithManager == 0) {
      return;
    }

    console.log(this.taskFromDateAllGraph, "*---------this.taskFromDate---------", this.taskToDateAllGraph)

    if (this.taskFromDateAllGraph == undefined && this.taskToDateAllGraph == undefined) {
      this.selectedFromDated = this.taskFromDateAllGraph;
      this.selectedtoDated = this.taskToDateAllGraph;
    }

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      loggdingUserId: this.userId,
      userID: this.loggdinUserIDBydefault,
      btn2BgColor: this.buttonColorName,
      arrEmployeeDetiails: this.arrEmployeeDetiails,
      selectedFromDated: this.selectedFromDated,
      selectedtoDated: this.selectedtoDated,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';


    console.log("dialogConfig-------------------------------------1510----------", dialogConfig)
    const dialogRef = this.dialog.open(ExpenseDashboardDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });

  }
  selectedEmployee: any = []
  onEmployeeChangeByManager(event: any) {

    this.forEmployeDDlogginUserID = event;
    this.loggdinUserIDBydefault = event;
    this.selectUserId = event;
    // this.selectFromDateThird = this.taskFromDate;
    // this.selectToDateThird = this.taskToDate;

    this.dashBoardreimbursmentData('allGraph');
    console.log("--------------------------getReimbursementCount 5--------------------------------");
    this.getReimbursementCount(this.reimbursementTypeCount, 'bar', this.selectedYearForDashboard, '', '');
    // this.getApprovedPaidAmountByCount('bar', this.selectedYearForThirdGraph, '', '');
    this.getApprovedPaidAmountByCount(
      'bar',
      this.selectedYearForThirdGraph
    );
    // Ensure date range values are passed correctly when graph switches


  };


  ngOnDestroy(): void {
    // Remove resize listener
    // window.removeEventListener('resize', this.onResize.bind(this));
  }

}
